import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  root: {
    display: 'flex'
  },
  content: {
    flexGrow: 1,
    height: '100vh'
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    justifyContent: 'center',
    marginBottom: '50px'
  },
  marginFiltersContainer: {
    marginTop: '-20px',
    marginBottom: '30px'
  },
  dataPicker: {
    width: '50%'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    marginTop: '15px'
  }
}));
